// extracted by mini-css-extract-plugin
var _1 = "I9AL_5bgTfTUY67V50Wn";
var _2 = "I9AL_5bgTfTUY67V50Wn";
export { _1 as "secondary-button", _2 as "secondaryButton" }
